import { editDeviceCalibrateResultRequest, getDeviceCalibrateResultRequest } from "@/service/parameterConfiguration";
import { Button, Divider, Form, Input, InputNumber, message } from "antd";
import { useEffect, useState } from "react";

interface iProps {
    id: number | string,
    sn: number | string,
    refreshTrigger?: number,
    onRefreshAll?: () => void
}

const AxForwardMmwRadarForm = (props: iProps) => {

    const { id, sn, refreshTrigger, onRefreshAll } = props
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearch, setHasSearch] = useState(false);


    const updateForm = async () => {
        let _formValue = {};
        try {
            setIsLoading(true);
            const res = await getDeviceCalibrateResultRequest({ id, sn });
            const data = res.data?.data || {};

            const parseNumber = (v: any) => (v === null || v === undefined || v === '' ? undefined : Number(v));

            _formValue = {
                version: data.version,
                success: parseNumber(data.success),
                locationX: parseNumber(data.locationX),
                locationY: parseNumber(data.locationY),
                locationZ: parseNumber(data.locationZ),
                pitch: parseNumber(data.pitch),
                yaw: parseNumber(data.yaw),
                roll: parseNumber(data.roll),
            };
            setHasSearch(true);
        } catch (err) {
            console.error("err", err);
        } finally {
            setIsLoading(false);
            form.setFieldsValue(_formValue);
        }

    }
    useEffect(() => {
        updateForm();
    }, [id, sn, refreshTrigger]);


    const submitForm = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields();
            const params = {
                id,
                ...values
            }
            const res = await editDeviceCalibrateResultRequest(params, sn);

            if (res.data.code === 0) {
                message.success('下发安行前向毫米波雷达标定结果成功');
                onRefreshAll?.();
            } else {
                message.error('下发安行前向毫米波雷达标定结果失败');
            }
        } catch (error) {
            console.error("submit failed:", error);
            message.error('下发安行前向毫米波雷达标定结果失败');
        } finally {
            setIsLoading(false);
        }
    }

    return <div>
        <Divider>安行前向毫米波雷达标定结果</Divider>
        <Form form={form} labelAlign="left" labelCol={{ span: 6, style: { whiteSpace: 'normal', overflowWrap: 'break-word' } }} wrapperCol={{ span: 14 }}>
            <Form.Item label="参数版本号" name="version" style={{ marginBottom: '20px' }}>
                <Input disabled={true} />
            </Form.Item>
            <Form.Item label="标定状态" name="success" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后位置x" name="locationX" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后位置y" name="locationY" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后位置z" name="locationZ" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后pitch" name="pitch" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后yaw" name="yaw" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后roll" name="roll" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <div style={{ textAlign: 'right' }}>
                <Button
                    type="primary"
                    disabled={!hasSearch}
                    loading={isLoading}
                    onClick={submitForm}
                >
                    下发安行前向毫米波雷达标定结果
                </Button>
            </div>
        </Form>
    </div>
};

export default AxForwardMmwRadarForm;
